import { DateFormats, formatDate } from '@strata/helper-functions';
import { FormSection } from '@strata/react-form-section';
import { Grid, SecondaryData } from '@strata/react-grid';
import PropTypes from 'prop-types';

const columns = [
    {
        header: 'Updated On',
        accessorKey: 'updated_on',
        size: 200,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    {
        header: 'User',
        accessorKey: 'updated_by',
        size: 250,
    },
];

export const AuditHistory = ({ data = undefined, isCreate = false }) => (
    <FormSection
        className="sds_audit-history"
        sectionTitle="History"
        isLoading={!(isCreate || data)}
        content={
            data?.length > 0 ? (
                <Grid
                    data={data}
                    columns={columns}
                    sortProperties={[{ id: 'updated_on', desc: true }]}
                />
            ) : (
                <div className="sds_audit-history--no-updates">No Updates Found</div>
            )
        }
    />
);

AuditHistory.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            updated_on: PropTypes.string.isRequired,
            updated_by: PropTypes.string.isRequired,
        }),
    ),
    isCreate: PropTypes.bool,
};
